const GOOGLE_MAPS_SEARCH_URL = 'https://www.google.com/maps/search/';

export class UrlHelper {

  static mayorUrl(originalTo: string) {

    const ret = window.location.protocol + '//' +
      UrlHelper.currentMayorDomain() +
      originalTo;

    return ret;

  }

  /** Hostname of the public site (and API): the backoffice one without its "backoffice." prefix. */
  static publicHostname(): string {
    return window.location.hostname.replace(/(^|\.)backoffice\./, '$1');
  }

  static publicOrigin(): string {
    return window.location.protocol + '//' + UrlHelper.publicHostname() +
      (window.location.port ? ':' + window.location.port : '');
  }

  /**
   * Public URL for public paths (landings, B2B register) opened on the backoffice host, e.g. QRs generated before
   * lockerLanding() existed. Null when the current URL belongs to the backoffice itself.
   */
  static legacyPublicUrl(): string | null {
    const location = window.location;
    if (UrlHelper.publicHostname() === location.hostname || !/^\/(l|platform)(\/|$)/.test(location.pathname)) {
      return null;
    }
    return UrlHelper.publicOrigin() + location.pathname + location.search + location.hash;
  }

  /** Same URL mayordomo sends to lockers and standalones (UrlHelperCompanyLandings::getLockerLanding). */
  static lockerLanding(lockerId: number): string {
    return UrlHelper.publicOrigin() + '/l/' + lockerId;
  }

  static b2bInviteRegister(code: string): string {
    return UrlHelper.publicOrigin() + '/platform/#/auth/register/' + encodeURIComponent(code);
  }

  static currentMayorDomain(): string {
    const hostname = window.location.hostname;
    return hostname.replace('smartpoint.ai', 'mayordomo.io');
  }

  static mayorLocker(lockerId: number): string {
    return UrlHelper.mayorUrl('/mayor/lockers/' + lockerId);
  }

  static mayorLockers(): string {
    return UrlHelper.mayorUrl('/mayor/lockers');
  }

  static mayorLockersServiceProviders(lockerId: number): string {
    return UrlHelper.mayorUrl('/mayor/lockers/' + lockerId + '/providers?stay');
  }

  static mayorLockerCells(lockerId: number): string {
    return UrlHelper.mayorUrl('/mayor/lockers/' + lockerId + '/disable/compartments');
  }

  static mayorOrder(orderId: number) {
    return UrlHelper.mayorUrl('/mayor/orders/' + orderId + '?stay');
  }

  static mayorOrderList() {
    return UrlHelper.mayorUrl('/mayor/orders/?stay');
  }

  static mayorOrderCreate() {
    return UrlHelper.mayorUrl('/mayor/orders/create-with-customer');
  }

  static mayorOrderEdit(orderId: number) {
    return UrlHelper.mayorUrl('/mayor/orders/' + orderId + '/edit');
  }

  static mayorOldRoutes(): string {
    return UrlHelper.mayorUrl('/mayor/routes');
  }

  static mayorOldRoute(routeId: number): string {
    return UrlHelper.mayorUrl('/mayor/routes/' + routeId);
  }

  static mayorOldRouteCreate(): string {
    return UrlHelper.mayorUrl('/mayor/routes/create');
  }

  static mayorPromotion(promotionId: number) {
    return UrlHelper.mayorUrl('/mayor/providers/2/promotions/' + promotionId + '/edit');
  }

  static mayorScreensaverEdit(screensaverId: number) {
    return { name: 'screensaverInfo', params: { screensaverId: String(screensaverId) } };
  }

  static mayorOldScreensaverEdit(screensaverId: number): string {
    return UrlHelper.mayorUrl('/mayor/lockers/1/screensavers/' + screensaverId + '/edit');
  }

  static mayorServiceProvidersCreateService(spId: number) {
    return { name: 'serviceCreate', params: { spId: String(spId) } };
  }

  static mayorServiceProvidersService(spId: number, serviceId: number) {
    return { name: 'serviceEdit', params: { spId: String(spId), serviceId: String(serviceId) } };
  }

  static mayorServiceProvidersServices(spId: number) {
    return { name: 'serviceProvidersServices', params: { spId: String(spId) } };
  }

  static mayorServiceProvidersPromotions(spId: number) {
    return { name: 'serviceProvidersPromotions', params: { spId: String(spId) } };
  }

  static mayorServiceProviderProducts(spId: number) {
    return { name: 'serviceProviderProducts', params: { spId: String(spId) } };
  }

  static mayorServiceProviderEdit(id: any) {
    return { name: 'serviceProvider', params: { spId: String(id) } };
  }

  static mayorServiceProviderCreate() {
    return { name: 'serviceProviderCreate' };
  }

  static mayorLandingpages():string {
    return UrlHelper.mayorUrl('/mayor/settings/landingpages');
  }

  static mayorInvoices(): string {
    return UrlHelper.mayorUrl('/mayor/invoices/?stay');
  }

  static mayorInvoice(invoiceId: number): string {
    return UrlHelper.mayorUrl('/mayor/invoices/' + invoiceId + '?stay');
  }

  static googleMapsPoint(lat: number, lng: number): string {
    return GOOGLE_MAPS_SEARCH_URL + '?api=1&query=' + encodeURIComponent(lat + ',' + lng);
  }

  static slugGenerator(name: string): string {
    return String(name)
      .normalize('NFKD') // split accented characters into their base characters and diacritical marks
      // NFKD = Compatibility Decomposition, followed by Canonical Composition.
      .replace(/[\u0300-\u036f]/g, '')
      // remove all the accents, which happen to be all in the \u03xx UNICODE block.
      .trim()
      // trim leading or trailing whitespace
      .toLowerCase()
      // convert to lowercase
      .replace(/[^a-z0-9 \- _]/g, '')
      // remove non-alphanumeric characters
      .replace(/\s+/g, '-')
      // replace spaces with hyphens
      .replace(/-+/g, '-');
      // remove consecutive hyphens
  }

}
